import React from "react";
import Heading from "./Heading";
import Description from "./Description";
import PropTypes from "prop-types";
import "./style.css";

const KnowMore = ({ data }) => {
  return (
    data && (
      <div id="overview" className="gradientStyle mt-[8vw] md:mt-[2vw]">
        <div className="px-[2vw] pb-[2vw]">
          <Heading
            heading={data?.heading}
            heading_color={data?.heading_color}
            heading_image={data?.underline_image}
            arrow_image={data?.arrow_image}
          />
          <Description
            data={data?.description}
            bg_color={data?.bg_color}
            richData={data?.rich_description}
          />
        </div>
      </div>
    )
  );
};

KnowMore.propTypes = {
  data: PropTypes.object,
};

export default KnowMore;
